var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#616161",
    strokeWidth: 2,
    fill: "#FFF",
    x: 1,
    y: 1,
    width: 22,
    height: 37,
    rx: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1h-.5C5.7 1 1 5.7 1 11.5V18h11V1Z",
    stroke: "#616161",
    strokeWidth: 2,
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18h-21",
    stroke: "#616161",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17V2",
    stroke: "#616161",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#616161",
    x: 10,
    y: 6,
    width: 4,
    height: 8,
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMouse);
export default ForwardRef;